import Ajax from 'global/od/Ajax';

export default (cartEntries = []) => {
	const data = JSON.stringify({ cartEntries });

	return Ajax({
		url: '/ajax/cart/add-products',
		method: 'POST',
		contentType: 'application/json',
		dataType: 'html',
		data,
	});
};
